import { DatasetEntry } from '@hooks/useCatalog'
import { DataSet } from 'src/types/global'

export function getSourceFromSchema(schema: string): 'mydata' | 'catalog' {
  return schema === 'keyed' ? 'mydata' : 'catalog'
}

export function processSearchResults(datasets: DatasetEntry[]): {
  myData: DataSet[]
  catalog: DataSet[]
} {
  const myData: DataSet[] = []
  const catalog: DataSet[] = []

  for (const item of datasets) {
    const source = getSourceFromSchema(item.schema)

    const uiItem: DataSet = {
      id: item.id,
      name: item.title,
      source: source
    }

    if (source === 'mydata') {
      myData.push(uiItem)
    } else {
      catalog.push(uiItem)
    }
  }

  return { myData, catalog }
}
